import type { Maybe, TrackingInfo } from '@seek/ca-myprofile-utils';
import Cookies from 'js-cookie';

import {
  Actions as CareerHistoryActions,
  type CareerHistoryAction,
} from 'src/components/Profile/CareerHistory/actions';
import {
  Actions as EducationActions,
  type EducationAction,
} from 'src/components/Profile/Education/actions';
import { getCandidateIdFromCache } from 'src/components/Profile/data';
import { trackUnconfirmedDataNudgeImpression } from 'src/modules/impression-tracking';
import type { Action, ApiClient } from 'src/types';

export const createImpressionTrackingMiddleware =
  ({ api }: { api: ApiClient }) =>
  () =>
  (next: (action: Action) => void) =>
  (action: CareerHistoryAction | EducationAction) => {
    const { type } = action;
    const sessionId = Cookies.get('JobseekerSessionId');

    if (
      sessionId &&
      (type === CareerHistoryActions.UNCONFIRMED_ROLE_IMPRESSION ||
        type === EducationActions.UNCONFIRMED_QUALIFICATION_IMPRESSION)
    ) {
      const candidateId = getCandidateIdFromCache(api.apolloClient.cache);

      if (candidateId) {
        let resource;
        if (type === CareerHistoryActions.UNCONFIRMED_ROLE_IMPRESSION) {
          const { id, company, title, from, to } = action.payload;
          resource = {
            careerHistory: {
              id,
              company: { name: company.text },
              role: { title: title.text },
              startDate: from,
              endDate: to,
            },
          };
        } else if (
          type === EducationActions.UNCONFIRMED_QUALIFICATION_IMPRESSION
        ) {
          const { id, name, institute, completed, completionDate, highlights } =
            action.payload;
          resource = {
            education: {
              id,
              name: name.text,
              institute: {
                name: institute.text,
                ontologyId: institute.ontologyId,
              },
              highlights,
              completed,
              ...(completionDate && completionDate.year
                ? {
                    completionDate: {
                      year: completionDate.year,
                      // @ts-expect-error Education type issue
                      month: completionDate.month,
                    },
                  }
                : {}),
            },
          };
        }

        const { tracking } = action.payload as {
          tracking?: Maybe<TrackingInfo>;
        };

        const trackingItem = tracking?.events?.find(
          (item) => item.key === 'served',
        );
        const servedNudgeId = trackingItem?.value;

        const data = {
          candidateId,
          sessionId,
          servedNudgeId,
          resource,
          page: 'My Profile',
        };
        trackUnconfirmedDataNudgeImpression(data);
      }
    }

    return next(action);
  };
